
class SharedBaseService {

    async login(username, password) {

        let url = `/api/v1/share/login`
        const header = {
            'Content-Type': 'application/json',
        }

        const response = await fetch(
            url,
            {
                method: 'POST',
                headers: header,
                credentials: 'same-origin',
                body: JSON.stringify({username: username, password: password}),
            }
        );

        if ( response.ok) {
            return await response.json();
        } else if ( response.status == 401) {
            throw Error("401")
        }
    }

}

export default SharedBaseService;